import axios from "axios";

export default function impersonate({ uuid }) {
  return new Promise((resolve, reject) => axios
    .post(`/account/system-admin/api/v1/users/${uuid}/impersonate`)
    .then((response) => resolve(response.data))
    .catch((error) => reject(error.message))
  );
}
